export default {"src":"/_next/static/media/chat.116cd63e.svg","height":100,"width":109,"blurWidth":0,"blurHeight":0};